$(document).ready(function() {

    // -------------------------- GLOBAL VARIABLES -------------------------- //

    var language = $("html").attr("lang");

    var is_mobile = {
        ios: (/iPhone|iPad|iPod/i.test(navigator.userAgent)),
        android: (/Android/i.test(navigator.userAgent)),
        windows: (/IEMobile/i.test(navigator.userAgent))
    };
    is_mobile.any = (is_mobile.ios || is_mobile.android || is_mobile.windows);

    var is_mac = (["Macintosh", "MacIntel", "MacPPC", "Mac68K"].indexOf(window.navigator.platform) !== -1);


    // -------------------------- HELPER FUNCTIONS -------------------------- //

    var scroll_to = function(element_or_position, offset, speed) {
        // speed: pixels per second, or null for no animation
        offset = offset !== undefined ? offset : 0;
        speed = speed !== undefined ? speed : 2000;
        var old_scroll = $(window).scrollTop();
        var new_scroll = (typeof element_or_position === "number") ? element_or_position : $(element_or_position).offset().top;
        new_scroll += offset;
        if (speed === null) {
            $("html, body").stop().scrollTop(new_scroll);
        }
        else {
            var duration = Math.abs(old_scroll - new_scroll) * 1000 / speed;
            $("html, body").stop().animate({scrollTop: new_scroll}, duration);
        }
    };


    // ----------- SHOW :HOVER, :ACTIVE, AND :FOCUS STYLES ON iOS ----------- //

    $(document).on("touchstart", function() {});


    // ---------------------- SVG IMAGES TO INLINE SVGs ---------------------- //

    $("img.svg-img").each(function() {
        var $img = $(this);
        var img_url = $img.attr("src");
        var img_class = $img.attr("class");
        var img_id = $img.attr("id");
        var img_style = $img.attr("style");
        var aspect_ratio = $img.data("aspect-ratio");

        $.get(img_url, function(data) {
            var $div = $('<div>').addClass(img_class);
            if (img_id) {
                $div.attr("id", img_id);
            }
            if (img_style) {
                $div.attr("style", img_style);
            }
            var $svg = $(data).find("svg");
            var $ratio = $('<div class="svg-img-ratio">');
            if (!aspect_ratio) {
                var view_box = $svg.attr("viewBox").split(" ");
                aspect_ratio = view_box[2] / view_box[3];
            }
            $ratio.css("padding-bottom", (1 / aspect_ratio * 100) + "%");
            $div.append($ratio);
            var $data = $('<div class="svg-img-data">').append($svg);
            $div.append($data);
            $img.replaceWith($div);
        }, "xml");
    });


    // -------------------- HEADER (HAMBURGER MENU, ETC.) -------------------- //

    $("header").each(function() {
        var $header = $(this);
        var is_overlay = $header.hasClass("is-overlay");
        var $nav = $header.find(".header-nav");
        var $hamburger = $header.find("a.header-hamburger");

        // Toggle the nav
        $hamburger.click(function() {
            $nav.addClass("is-visible");
        });

        // Click outside the nav when it's open
        $(document).on("click touchstart", function(e) {
            var $target = $(e.target);
            if ($nav.hasClass("is-visible") && $target.closest($nav.add($hamburger)).length === 0) {
                $nav.addClass("is-animating").removeClass("is-visible");
                setTimeout(function() {
                    $nav.removeClass("is-visible");
                }, 500);
            }
        });

        // Toggle the "is-overlay" class based on the scrolling position
        if (is_overlay) {
            $(document).on("scroll", function(e) {
                if ($(document).scrollTop() > $("main").children().first().next().offset().top) {
                    $header.addClass("was-overlay").removeClass("is-overlay");
                }
                else {
                    $header.addClass("is-overlay").removeClass("was-overlay");
                }
            });
        }
    });


    // ------------------------------ SLIDESHOW ------------------------------ //

    $(".home-top-slideshow").each(function() {
        var $slideshow = $(this);
        var interval_duration = 5000;
        var interval = null;
        var $slides = $slideshow.find("ul.home-top-slideshow-slides").children();
        var $nav = $slideshow.find("ul.home-top-slideshow-nav");
        var $nav_bullets = $();

        var get_active_slide = function() {
            return $slides.filter(".is-active");
        };

        var go_to_slide = function($slide) {
            var $old_slide = get_active_slide();
            if ($old_slide.index() === $slide.index()) {
                return;
            }
            $old_slide.removeClass("is-active");
            $slide.addClass("is-active");
            $nav_bullets.removeClass("is-active");
            $nav_bullets.eq($slide.index()).addClass("is-active");
            set_interval();
        };

        var go_to_next_slide = function() {
            var $active_slide = get_active_slide();
            var $next_slide = $active_slide.next();
            if ($next_slide.length === 0) {
                $next_slide = $slides.first();
            }
            go_to_slide($next_slide);
        };

        var go_to_previous_slide = function() {
            var $active_slide = get_active_slide();
            var $previous_slide = $active_slide.prev();
            if ($previous_slide.length === 0) {
                $previous_slide = $slides.last();
            }
            go_to_slide($previous_slide);
        };

        var clear_interval = function() {
            clearInterval(interval);
        };

        var set_interval = function() {
            clear_interval();
            interval = setInterval(go_to_next_slide, interval_duration);
        };

        // Make first slide active
        $slides.first().addClass("is-active");

        // Add bullets based on number of slides
        if ($slides.length > 1) {
            $slides.each(function() {
                $nav_bullets = $nav_bullets.add($("<li>"));
            });
            $nav.append($nav_bullets);
            $nav_bullets.first().addClass("is-active");
        }

        // Click on bullets
        $nav_bullets.click(function() {
            go_to_slide($slides.eq($(this).index()));
        });

        // Set interval
        set_interval();
    });


    // -------------- SHOW WARNING IF TRYING TO PURCHASE ON MAC -------------- //

    $("a[href$='/store'], a[href$='/boutique']").click(function() {
        if (is_mac) {
            alert(
                language === "fr" ?
                    "Nous détectons que vous êtes sur un ordinateur Mac. Sachez que Mastro ne fonctionne que sur le système d'exploitation Windows. Vous pouvez rouler Windows sur votre Mac avec Boot Camp, ou encore avec un logiciel de virtualisation comme Parallels Desktop, VMware Fusion ou VirtualBox."
                :   "We detect that you are on a Mac computer. Please be aware that Mastro only works on the Windows operating system. You can run Windows on your Mac with Boot Camp, or with a virtualization software such as Parallels Desktop, VMware Fusion, or VirtualBox."
            );
        }
    });
 
});
